import React from 'react';

import { useTheme } from 'styled-components';
import Image from 'next/image';

import Tooltip from '@components/ui/Tooltip/next';
import { RatingViewModel } from '@api/v3';
import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';
import {
  getRating,
  getRatingAboveFour,
} from '@components/views/hotel/detail/components/scoring/getReviewIcon';

import {
  Container,
  ExpediaScoring,
  MainTitle,
  Note,
  NoteWrapper,
  Percent,
  PercentWrapper,
  ScoringLine,
  Separate,
  SpanWrapper,
  TitleProgressContainer,
  TooltipContainer,
  TooltipTitle,
  TotalContainer,
  TotalPercent,
  Wrapper,
  WrapperTitle,
} from './styled';
import ProgressBar from './ProgressBar';

export type ScoringProps = {
  totalScoring?: number;
  reviews?: RatingViewModel;
};

const ExpediaScoringBanner = ({ totalScoring, reviews }: ScoringProps) => {
  const { palette } = useTheme();
  return (
    <Container>
      <Wrapper>
        <Tooltip
          zIndex={10}
          getPopupContainer={(triggerNode) => triggerNode}
          overlayInnerStyle={{
            backgroundColor: palette.white,
            color: palette.darkGray,
            lineHeight: 1.43,
            width: '250px',
            minHeight: '198px',
            marginTop: '0',
            borderRadius: '8px',
            boxShadow:
              '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
          }}
          showArrow={false}
          placement='bottomRight'
          title={
            <>
              <TotalContainer>
                <TitleProgressContainer>
                  <TooltipTitle>
                    <MainTitle>Genel Toplam</MainTitle>
                  </TooltipTitle>
                  <ScoringLine>
                    <ProgressBar value={reviews?.rating?.value} maxValue={5} />
                  </ScoringLine>
                </TitleProgressContainer>
                <PercentWrapper>
                  <TotalPercent>{reviews?.rating?.value}/5</TotalPercent>
                </PercentWrapper>
              </TotalContainer>
              {reviews?.rating?.subratings?.map((item) => (
                <div key={item.key}>
                  <TooltipContainer>
                    <TitleProgressContainer>
                      <TooltipTitle>{item.localizedName}</TooltipTitle>
                      <ScoringLine>
                        <ProgressBar value={item.value} maxValue={5} />
                      </ScoringLine>
                    </TitleProgressContainer>
                    <PercentWrapper>
                      <Percent>{item.value}/5</Percent>
                    </PercentWrapper>
                  </TooltipContainer>
                </div>
              ))}
              <Separate />
              <NoteWrapper>
                <Image
                  src='/static/images/expedia.png'
                  width={50}
                  height={10}
                  alt='expedia'
                />
                <Note>
                  Otel puanı hiçbir müdahale olmaksızın Expedia’dan
                  alınmaktadır.
                </Note>
              </NoteWrapper>
            </>
          }
        >
          <ExpediaScoring>
            <WrapperTitle>
              <Typography variant='caption3' weight='Regular'>
                Misafir Puanı
              </Typography>
              <Typography variant='caption3' weight='Bold'>
                {getRating(totalScoring ?? 0)}
              </Typography>
            </WrapperTitle>
            <SpanWrapper colorRating={getRatingAboveFour(totalScoring ?? 0)}>
              <CustomIcon icon={InfoIcon} paletteColor='NL0' fontSize={14} />
              <Typography variant='caption3' weight='SemiBold' color='NL0'>
                {totalScoring}/5
              </Typography>
            </SpanWrapper>
          </ExpediaScoring>
        </Tooltip>
      </Wrapper>
    </Container>
  );
};
export default ExpediaScoringBanner;
